// Module
var code = "<add-recipe></add-recipe>";
// Exports
var _module_exports = code;;
var path = 'app/components/add-recipe/add-recipe.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;